// This file is auto-generated by "@aria-ui/cli". Do not edit this file directly.

import { registerTableHandleRowPopupElement, type TableHandleRowPopupElement } from '@prosekit/web/table-handle';
import { createElement, forwardRef, useCallback, useRef, type ForwardedRef, type ForwardRefExoticComponent, type HTMLAttributes, type RefAttributes } from 'react';

/** Props for the {@link TableHandleRowPopup} React component. */
export interface TableHandleRowPopupProps {}

function TableHandleRowPopupComponent(props: TableHandleRowPopupProps, forwardedRef: ForwardedRef<TableHandleRowPopupElement>) {
  registerTableHandleRowPopupElement();

  const elementRef = useRef<TableHandleRowPopupElement>(null);

  const { ...restProps } = props;

  const mergedRef = useCallback(
    (element: TableHandleRowPopupElement | null) => {
      elementRef.current = element;
      if (typeof forwardedRef === 'function') {
        forwardedRef(element);
      } else if (forwardedRef) {
        forwardedRef.current = element;
      }
    },
    [forwardedRef],
  );

  return createElement('prosekit-table-handle-row-popup', { ...restProps, ref: mergedRef, suppressHydrationWarning: true });
}

/** A React component that renders an `prosekit-table-handle-row-popup` custom element. */
export const TableHandleRowPopup: ForwardRefExoticComponent<TableHandleRowPopupProps & HTMLAttributes<TableHandleRowPopupElement> & RefAttributes<TableHandleRowPopupElement>> = /* @__PURE__ */ forwardRef(TableHandleRowPopupComponent);
